import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

export const AvisoDePrivacidadNowPorts = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;

  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Política de Privacidad
        </Typography>

        <Typography color={theme?.palette?.primary?.dark} textAlign={"center"} fontWeight={400} fontSize={font_text} mt={2}>
          Política de privacidad para Avenida Vessel S.A.P.I. DE C.V., SOFOM, E.N.R. (“Nowports Capital”) y/o cualquiera
          de sus empresas filiales, subsidiarias y/o que pertenecen o son controladas por Nowports Inc.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={4}
        >
          De conformidad con lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los
          Particulares y su Reglamento (en su conjunto la “Ley”), se emite el presente Aviso de Privacidad en los
          siguientes términos (el “Aviso de Privacidad”) :
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Avenida Vessel S.A.P.I. DE C.V., SOFOM, E.N.R. (<span className="text-underline">“Nowports Capital”</span>) le
          informa que es la entidad “Responsable” del tratamiento de sus datos personales, estamos ubicados en Avenida
          Insurgentes Sur 601, Piso 18, Oficina 18-113, Col. Nápoles, Benito Juárez, CP 03810, Ciudad de México, México
          (el <span className="text-underline">“Domicilio Nowports”</span>).
          <br />
          Nowports.com es nuestra página web oficial, por lo tanto en Nowports no nos hacemos responsables de sitios de
          terceros que imiten, sean similares o que tengan un nombre de dominio que sea similar en grado de confusión al
          de la Web.
          <br />
          Al utilizar la Web, usted acepta que Nowports recolecte, almacene, y proporcione sus datos personales como se
          describe en el Aviso de Privacidad. Si usted no está de acuerdo con estas prácticas está en su derecho de
          suspender el uso de la Web cuando lo desee.
          <br />
          Respetamos su privacidad por lo que sus datos personales serán tratados con base en los principios de licitud,
          finalidad, lealtad, consentimiento, calidad, proporcionalidad, información y responsabilidad en términos de la
          Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Responsable de los datos personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Le informamos que en Nowports Capital recolectamos sus datos personales de las siguientes formas:
          <br />
          <strong>Personal:</strong> Cuando usted entregue personalmente a Nowports Capital o a cualquiera de sus
          representantes o empleados, sus datos personales a través de formularios y/o solicitudes.
          <br />
          <strong>Directa:</strong> Cuando usted proporcione sus datos personales ya sea a través de la Web, vía
          telefónica o cualquier otro medio tecnológico.
          <br />
          <strong>Indirecta:</strong> De cualquier otra fuente de información, comercialmente disponible o que esté
          prevista en la Ley.
          <br />
          La información proporcionada por usted, debe de ser veraz y completa y en ningún caso será Nowports Capital
          responsable de la veracidad de la misma. Sin embargo, Nowports Capital podrá realizar los análisis, reportes,
          entrevistas por cualquier medio, así como la verificación de datos a través de fuentes de acceso público o a
          través de terceros contratados para comprobar la veracidad de los datos que fueron proporcionados por usted.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Datos Personales sujetos al Tratamiento por Nowports Capital
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Con el fin de realizar las finalidades descritas en el presente Aviso de Privacidad Las categorías de datos
          personales a recabar y sujetas a tratamiento son (i) Datos de identificación y contacto (Nombre, teléfono,
          correo, CURP, RFC, dirección, referencias) (Estos datos van a ser transferidos a TREBOL, LEGALARIO, Rapyd,
          XEPELIN, y SOLUNION (Trebol Technology Colombia SAS, Legalario, S.A. de C.V. y Rapyd Financial Technology US,
          INC., Operadora Falcon, S.A.P.I. de C.V., SOFOM E.N.R., y Solunion México Seguros de Crédito S.A), (ii) Datos
          patrimoniales (acta constitutiva, acta de asamblea, dinero, bienes muebles e inmuebles; información fiscal;
          historial crediticio; ingresos y egresos; cuentas bancarias; (Estos datos van a ser transferidos a TREBOL
          (Trebol Technology Colombia SAS) con la finalidad de validar su información. Seguros; afores; fianzas, número
          de tarjeta de crédito, número de seguridad), (iii) Datos financieros (Estados de cuenta, estados financieros),
          (iv) Datos crediticios por medios electrónicos tales como NIP (Reporte de Buro de Credito), y (v) Datos de la
          empresa (Nombre, teléfono, correo, RFC, dirección, estructura accionaria, referencias, ingresos, CIEC y
          contraseña del SAT (Estos datos van a ser transferidos a Ekatena (NARRIX, S.A. DE C.V y ) con la finalidad de
          obtener información y documentos del SAT. El titular está de acuerdo con dicha transferencia de datos y su
          almacenamiento por parte de Avenida Vessel S.A.P.I. DE C.V., SOFOM, E.N.R., empresas relacionadas, Ekatena,
          Trebol, Legalario, Rapyd, Xepelin y Solunion.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Datos Personales Sensibles
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Son susceptibles de ser considerados como datos personales sensibles los datos financieros, fiscales,
          patrimoniales y crediticios por lo que Nowports Capital establece medidas especiales correspondientes para el
          tratamiento de dichos datos personales sensibles.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Finalidades del Tratamiento de Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El tratamiento de los datos personales que se recaben tiene como finalidad primaria la asesoría, contratación,
          comercialización y operación de servicios y productos financieros que usted contrate con Nowports Capital; así
          como llevar a cabo cualquier notificación y atender requerimientos legales de autoridades competentes. Como
          finalidad secundaria, Nowports Capital también utilizará sus datos personales para el diseño, desarrollo,
          análisis, publicidad y promoción de productos y servicios financieros.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Transferencia de Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nowports Capital podrá realizar la transferencia y/o remisión, nacional e internacional, de datos a{" "}
          <strong>(i) Nowports S.A. de C.V. y otras empresas afiliadas y/subsidiarias</strong>, para llevar a cabo la
          prestación del servicio solicitado o contratado así como aquellas finalidades secundarias previstas en el
          apartado 5 anterior del presente Aviso de Privacidad,{" "}
          <strong>(ii) Terceros proveedores o prestadores de servicios</strong> con los que Nowports Capital tenga
          obligaciones legales adquiridas, <strong>(iii) Terceros proveedores de servicios</strong> de investigación,
          análisis de datos, envío de información enfocada a las necesidades del titular de los datos personales así
          como la realización de servicios financieros o requerimientos por el titular de datos personales,{" "}
          <strong>(iv) Socios comerciales</strong> con los que Nowports Capital lleve a cabo convenios o contratos
          enfocados al desarrollo y comercialización de nuevos productos y/o servicios financieros en beneficio del
          titular y de acuerdo a sus necesidades, <strong>(v) Entidades terceras</strong> en caso de ser adquiridos,
          fusionados o cualquier otra transacción comercial, <strong>(vi) Autoridades competentes</strong> para dar
          cumplimiento a disposiciones legales aplicables o en caso de ser legalmente requeridos,{" "}
          <strong>(vii) Sociedades o compañías</strong> encargadas de investigaciones de fraude, lavado de dinero y
          recolección de pagos, y <strong>(viii) auditores</strong>. <br />
          Asimismo Nowports Capital compartirá sus datos personales cuando: <strong>(i)</strong> esté prevista en una
          Ley o Tratado en el que México sea parte; <strong>(ii)</strong> sea precisa para el mantenimiento o
          cumplimiento de una relación jurídica entre Nowports Capital y el titular; y <strong>(iii)</strong> sea con
          base en los demás supuestos establecidos en la Ley. Los terceros y las entidades receptoras de datos
          personales tendrán conocimiento de los términos a los cuales usted sujetó el tratamiento de sus datos
          personales, establecidos en el presente Aviso de Privacidad y asumen las mismas obligaciones y/o
          responsabilidades de Nowports Capital. Si usted no desea que sus datos personales sean transferidos respecto
          de aquéllas sobre las cuáles es necesario su consentimiento, le pedimos que envíe un correo electrónico al
          Departamento de Datos Personales:{" "}
          <a href="financing.mexico@nowports.com" style={{ color: theme?.palette?.primary?.main }}>
            <strong>financing.mexico@nowports.com</strong>
          </a>
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Hacemos de su conocimiento que usted puede, en cualquier momento, limitar el uso o divulgación de sus datos
          personales, así como negar o revocar la autorización para su tratamiento, mediante el ejercicio de los
          derechos de acceso, rectificación, cancelación u oposición (<strong>“Derechos ARCO”</strong>) que la ley
          prevé.
          <br />
          El ejercicio de los Derechos ARCO deberá de hacerse mediante una solicitud para la cual ponemos a su
          disposición la línea telefónica de atención a los Derechos ARCO 55 9274 411, asimismo puede enviarnos un
          correo electrónico a <strong>financing.mexico@nowports.com</strong> especificando el motivo de su solicitud.
          <br />
          El Departamento de Datos Personales acusará recibo de su solicitud 24 horas hábiles a la fecha en la que haya
          sido recibida y si es necesario, solicitará información adicional a fin de dar debido trámite a la misma.
          <br />
          Adicionalmente, en caso de que usted tenga cualquier duda o comentario relacionado con sus datos personales,
          el ejercicio de sus derechos o la seguridad de los mismos, puede comunicarse con el Departamento de Datos
          Personales llamando al teléfono 55 9274 411.
          <br />
          Así también, le informamos que usted tiene derecho a iniciar un Procedimiento de Protección de Derechos ante
          el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI) (
          <a href="http://www.inai.org.mx">http://www.inai.org.mx</a>) dentro de los 15 (quince) días hábiles siguientes
          a la fecha en que reciba la respuesta, o en caso de no recibir respuesta, a partir de que concluya el plazo de
          20 (veinte) días hábiles contados a partir de la fecha de recepción de su solicitud de ejercicio de Derechos
          ARCO.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Medios para Limitar el Uso o Divulgación de sus Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Usted podrá limitar el uso o divulgación para el tratamiento de sus datos personales, sin que se le atribuyan
          efectos retroactivos, enviando una solicitud por escrito al Departamento de Datos Personales, ya sea por
          mensajería al Domicilio Nowports o al correo electrónico <strong>financing.mexico@nowports.com</strong>.
          <br />
          En un plazo no mayor de 10 (diez) días hábiles, contados desde la fecha de recepción de su solicitud. Si
          resulta procedente su solicitud, se hará efectiva la misma dentro de los 15 (quince) días hábiles siguientes a
          la fecha en que se comunique la respuesta al correo electrónico que nos proporcione para tales efectos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Cierre de su Cuenta
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En el momento en que usted cierre su cuenta, Nowports Capital removerá su información personal tan pronto como
          sea posible, basándose en la actividad de su cuenta y de acuerdo con las leyes que apliquen.
          <br />
          Solamente retenemos información de cuentas cerradas para cumplir con la ley, prevenir fraude, recolectar pagos
          pendientes, resolver disputas, problemas con el funcionamiento de Nowports Capital, asistir en
          investigaciones, hacer cumplir nuestros Términos y Condiciones, y tomar decisiones permitidas por la ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Uso de Cookies
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En la Web utilizamos cookies propias y de empresas colaboradoras para mejorar su experiencia de usuario y la
          publicidad adaptada a sus hábitos de navegación. Si navegas por la Web, entenderemos que consientes el uso de
          las cookies en las condiciones establecidas en el presente aviso de privacidad y la política de uso de cookies
          publicada en la Web. Dicha política puede ser actualizada, por lo que te invitamos a revisarla de forma
          regular.
          <br />
          Usted está en su derecho de prevenir que cookies sean guardados en su disco duro haciendo los cambios
          correspondientes a la configuración de su navegador web. Sin embargo, desactivar los cookies puede resultar en
          funcionalidad limitada.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Consentimiento
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Al utilizar la Web o aplicación, y/o al contratar los servicios que ofrecemos se entenderá que nos ha otorgado
          su consentimiento.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Cambios al Aviso de Privacidad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El presente Aviso de Privacidad podrá ser revisado y modificado periódicamente para adaptarlo a procedimientos
          y prácticas internas y a las reformas legales que entren en vigor. Cualquier cambio al presente Aviso de
          Privacidad le será informado a través de (i) Avisos en la Web, y (ii) Cualquier otro medio de comunicación
          público o privado previstos en los contratos que amparan las operaciones celebradas entre el titular de los
          datos personales y Nowports Capital.
          <br />
          En todo caso, recomendamos visitar la Web frecuentemente. En caso de dudas acerca del presente Aviso de
          Privacidad, por favor envíe un correo electrónico a la dirección del Departamento de Protección de Datos:
          <strong>financing.mexico@nowports.com</strong>.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          Legislación Aplicable
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El presente Aviso de Privacidad está sujeto a la legislación aplicable en la República Mexicana, en especial,
          por lo dispuesto en la Ley y la demás normativa vinculada aplicable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={4}
        >
          <small>UNE</small>
          <br />
          <br />
          Contacto de la Unidad Especializada de Nowports Capital (Avenida Vessel S.A.P.I. DE C.V., SOFOM, E.N.R.) Para
          la atención de cualquier aclaración, queja o duda con relación a nuestros servicios, la cual dará respuesta en
          un plazo no mayor a 30 días hábiles
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <small>
            <strong>Datos</strong>
          </small>
          <br />
          <br />
          <strong>Titular de la UNE:</strong> Claudio Cañizo <br />
          <strong>Domicilio:</strong> Avenida Insurgentes Sur 601, Piso 18, Oficina 18-113, Col. Nápoles, Benito Juárez,
          CP 03810, Ciudad de México, México <br />
          <strong>Horario de Atención:</strong> lunes a viernes de 09:00 am a 5:00 pm <br />
          <strong>Teléfonos:</strong> + 52 55 9274 411 <br />
          <strong>Correo Electrónico:</strong> financing.mexico@nowports.com
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          <small>
            <strong>CONDUSEF</strong>
          </small>
          <br />
          <br />
          Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros <br />
          <strong>Dirección:</strong> Avenida Insurgentes Sur número 762, Colonia del Valle, Delegación Benito Juárez,
          Código Postal 03100, Ciudad de México. <br />
          <strong>Teléfono:</strong> 53-40-09-99. Del interior de la República sin costo: 01-800-999-80-80 <br />
          <strong>Página de Internet:</strong> <a href="www.condusef.gob.mx">www.condusef.gob.mx</a> <br />
          <br />
          <strong>FECHA DE ÚLTIMA ACTUALIZACIÓN: Junio de 2024.</strong>
          <br />
          <br />
        </Typography>
      </Box>
    </>
  );
};
